/**
 * <s-shuffle> randomly reorders the <li> items of the list inside it each time it is rendered,
 * so the search panel's suggested products change on every visit.
 */
class Shuffle extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('ul, ol');
    if (!list) return;
    const items = Array.from(list.children);
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    list.append(...items);
    // Snap scrolling would otherwise follow the moved card mid-row; always start from the first product (start edge, RTL-safe).
    const toStart = () => list.scrollTo({ left: 0, behavior: 'instant' });
    toStart();
    requestAnimationFrame(toStart);
    window.addEventListener('pageshow', toStart, { once: true });
  }
}

if (!customElements.get('s-shuffle')) customElements.define('s-shuffle', Shuffle);
